export type {
  FilterNode,
  PredicateNode,
  RangeNode,
  AndNode,
  OrNode,
  NotNode,
  ComparisonOperator,
  BaseNode,
} from "./nodes";
export type { Cesium3dTileStyleConditionFormatter } from "./Cesium3dTileStyleConditionFormatter";

import {
  and,
  or,
  not,
  predicate,
  eq,
  neq,
  gt,
  gte,
  lt,
  lte,
  range,
  fromFacets,
} from "./builder";
import { format } from "./format";
import { toCesium3dTileStyleCondition } from "./Cesium3dTileStyleConditionFormatter";

export const Search = {
  //logical operators
  and,
  or,
  not,
  //comparison operators
  eq,
  neq,
  gt,
  gte,
  lt,
  lte,
  //special operators
  predicate,
  range,
  fromFacets,
  //formatters
  format,
  toCesium3dTileStyleCondition,
} as const;
